<template>
  <vs-popup id="popup" :title="title" :active.sync="showPopup">
    <search-nav useReset @handleSearch="handleClickSearch" @resetSearch="resetSearch">
      <component v-if="searchComponent" :is="searchComponent" v-model="search" />
      <div v-else class="search-layout w-full grid col-gap-4 flex-wrap xl:flex">
        <component
          v-for="(component, index) in stdSearchComponents"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="handleClickSearch"
          @onSearch="handleClickSearch"
          v-model="search[component['value']]"
        />
      </div>
    </search-nav>
    <div class="overflow-x-auto">
      <table>
        <colgroup>
          <col v-if="multiSelect" width="60" />
          <col width="60" />
          <col v-for="(head, head_i) in listFileData.getHead()" style="min-width: 200px" />
        </colgroup>
        <thead>
        <th v-if="multiSelect"><vs-checkbox @change="handleCheckAll" class="form-group__header-title title-checked" :value="allChecked"></vs-checkbox></th>
        <th>No.</th>
        <th v-for="head in listFileData.getHead()" :key="`table_th_${head.name}`">
          {{ head.name }}
        </th>
        </thead>
        <tbody>
        <tr v-if="boardList.length === 0">
          <td :colspan="multiSelect ? listFileData.getHead().length + 2 : listFileData.getHead().length + 1" style="padding: 60px 0">검색된 문서가 없습니다.</td>
        </tr>
        <tr v-for="(item, item_i) in boardList" :key="`table_row_${item_i}`" @click="selectRowData(item)" :class="selectData && selectData.id == item.id && 'select-row'">
          <td v-if="multiSelect" @click.stop><vs-checkbox :value="getChecked(item.id)" @change="checkForm($event, item)" /></td>
          <td>{{ item.id }}</td>
          <td v-for="(head, head_i) in listFileData.getHead()" :key="`table_td_${head.name}`">

            <!-- const trData = getColData(head_i, item) 처럼 사용하기 위해서 template 에  v-for 를 활용 -->
            <template v-for="trData in [getColData(head_i, item)]">
              <div v-if="trData && trData.type === 'colorBox'">
                <div v-if="trData.text" class="flex items-center justify-center">
                  <p :style="trData.color ? `background:${trData.color}` : ''" :class="trData.color ? `text-white` : ''" style="font-size: 14px; font-weight: 500; text-align: center; padding: 2px 7px; border-radius: 4px">
                    {{ trData.text }}
                  </p>
                </div>
                <span v-if="trData.files && trData.files.length === 0" v-html="trData.empty || '-'"></span>
              </div>
              <div v-else>
                {{ trData }}
              </div>
            </template>
          </td>
        </tr>
        <!-- fake -->
        <tr v-for="_ in fakeList" class="fake">
          <td v-if="multiSelect"></td>
          <td><p style="height: 21px"></p></td>
          <td v-for="(__, _i) in listFileData.getHead()" :key="`table_faketd_${_i}`"></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="vs-con-table mb-6">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination :total="page.lastPage ? page.lastPage : 1" :value="page.current" @change="handleChangePage" />
        <!--        <vs-button v-if="checkList.length > 0" class="" color="secondary" type="border" style="width: 150px; position: absolute" @click="onClickUse">불러오기</vs-button>-->
      </div>
    </div>

    <div class="flex justify-end gap-4">
      <vs-button color="secondary" type="border" style="width: 112px" @click="cancelBtn">취소</vs-button>
      <vs-button color="secondary" style="width: 112px" @click="onClickUse">선택완료</vs-button>
    </div>
  </vs-popup>
</template>

<script>
import KPagination from "@/components/kPagination/kPagination";
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";

import normalSearchNav from "@/views/boards/components";
import singlePageList from "@/views/boards/single-page/listIndex";

import moment from "moment";
import searchComponent from "@/views/list/components/include";
import tabItems from "@/views/boards/tab/tab-items";

export default {
  name: "PopupLoadPrevBoard",
  components: {
    KPagination,
    SearchNav,
    SearchNavStartEnd,
    SearchNavItemKeyword,
    SearchNavItemSelect,
  },
  props: {
    title: {
      type: String,
      default: "이전 문서 불러오기",
    },
    setBoardId: Number,
    multiSelect: Boolean,
    value: { type: Boolean, default: false },

    // 검색조건을 List.js 의 getConditions 함수를 사용하지 않고, 별도로 설정할 때 사용된다.
    setConditions: Function,
  },
  data() {
    return {
      showPopup: this.value,
      // 페이징
      page: {
        current: 1,
        lastPage: 1,
        perPage: 10,
      },
      // 검색
      search: {
        value: {},
        loading: false,
        conditions: [],
      },
      boardList: [],
      fakeList: [],

      selectData: null,

      // boardList[i].checked 로 처리하려고 했으나, checkbox가 작동하지 않는 문제가 있어서 checkList를 따로 만들었다.
      checkList: [],
    };
  },
  created() {
    this.boardList = [];
    this.fakeList = [];
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return this.setBoardId ? this.setBoardId : parseInt(this.$route.params.boardId);
    },
    listFileData() {
      return singlePageList[`${this.boardId}_list`];
    },
    searchComponent() {
      return normalSearchNav[`NormalSearchNav${this.boardId}`];
    },
    allChecked() {
      for (const data of this.boardList) {
        if (!this.getChecked(data.id)) {
          return false;
        }
      }
      return true;
    },
    stdSearchComponents() {
      if (singlePageList[`${this.boardId}_list`]) {
        const getComponents = singlePageList[`${this.boardId}_list`].components;
        if (getComponents) {
          const stdSearchComponents = getComponents();
          if (stdSearchComponents && stdSearchComponents.length > 0) {
            for (const component of stdSearchComponents) {
              component.component = searchComponent[component["component"]];
            }
          }
          return stdSearchComponents;
        }
      }
      return [];
    },

    tab () {
      return tabItems[this.boardId] || {}
    }
  },
  watch: {
    value: {
      handler(value) {
        this.showPopup = value;
        if (value) {
          this.loadBoardList();
          this.page.current = 1;
        }
      },
    },
    showPopup(value) {
      const body = document.querySelector("body");
      if (value) {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "auto";
      }
      this.$emit("input", value);
    },
  },
  methods: {
    cancelBtn() {
      this.showPopup = false;
    },
    onClickUse() {
      this.showPopup = false;
      if (this.multiSelect) this.$emit("selectRowData", this.checkList);
      else this.$emit("selectRowData", this.selectData);
    },
    getChecked(id) {
      return this.checkList.map((value) => value.id).indexOf(id) >= 0;
    },
    checkForm($event, post) {
      const checked = $event.target.checked;
      if (checked) {
        const item = { id: post.id, content: this.getContent(post) };
        this.checkList.push(item);
      } else {
        this.checkList.splice(this.checkList.map((value) => value.id).indexOf(post.id), 1);
      }
    },
    handleCheckAll($event) {
      const checked = $event.target.checked;
      if (checked) {
        for (const post of this.boardList) {
          if (!this.getChecked(post.id)) {
            const item = { id: post.id, content: this.getContent(post) };
            this.checkList.push(item);
          }
        }
      } else {
        this.checkList = [];
      }
    },
    resetSearch() {
      const _search = JSON.parse(JSON.stringify(this.search));
      _search.loading = false;
      if (_search.date) {
        _search.date = { startDate: "", endDate: "" };
      }
      _search.column.keyword = "";

      this.search = _search;

      this.handleClickSearch();
    },
    handleClickSearch() {
      this.page.current = 1;
      this.loadBoardList();
    },
    handleChangePage(page) {
      this.page.current = page;
      this.loadBoardList();
    },

    initSort() {
      const { sortKey, orderBy } = this;
      // 정렬 순서가 정해졌을 때에만 해당 컬럼의 정보를 추출한다
      if (orderBy) {
        this.orderDirection = orderBy;
        const target = this.getColumnKey(sortKey);
        if (target) {
          this.orderTarget = target;
        } else {
          // 만약 target이 없다면, 해당 컬럼의 정보를 찾아서 정렬한다
          const target = this.findKeyWithHead(sortKey);
          this.orderTarget = target || "created_at";
        }
      }
      // 정렬이 해제될 때에는 기본 컬럼을 "created_at"으로 설정한다
      else {
        this.orderDirection = "desc";
        this.orderTarget = "created_at";
        if (singlePageList[`${this.boardId}_list`].getDefaultSort) {
          const sort = singlePageList[`${this.boardId}_list`].getDefaultSort();
          this.orderTarget = sort.target;
          this.orderDirection = sort.order;
        }
      }
    },
    initSearchKeyValue() {
      let keyValue = {};
      let keyword = [];

      if (this.boardId) {
        if (singlePageList[`${this.boardId}_list`]) {
          keyValue = singlePageList[`${this.boardId}_list`].getSearchKeyValue(this.nav);
          keyword = singlePageList[`${this.boardId}_list`].getSearchKeyword(this.nav);
        }

        if (keyword) {
          keyword = keyword.map((_keyword) => {
            const k = _keyword
              .replace("default_skw", `nav.page.p${this.$route.params.boardId}.searchKeyword`)
              .replace("default_disaster", `nav.page.p${this.$route.params.boardId}.disasterType`)
              .replace("default_field_name", `nav.page.p${this.$route.params.boardId}.fieldName`);
            return k;
          });
        }

        if (typeof this.nav !== "undefined") {
          this.nav.page[`p${this.boardId}`] = keyValue;
          this.nav.keyword = keyword;
        }
      }
    },
    initSearchCompanies() {
      const func = singlePageList[`${this.boardId}_list`] && singlePageList[`${this.boardId}_list`].getCompanies;
      if (func) {
        this.nav.companies = func(this.nav, this.$store);
      }
    },
    initSearchConditions() {
      const func = singlePageList[`${this.boardId}_list`] && singlePageList[`${this.boardId}_list`].getConditions;
      if (func) {
        this.search.conditions = func({ value: this.search });
      }
      if (this.setConditions) {
        this.search.conditions = this.setConditions(this.search, this.search.conditions);
      }
    },

    async loadBoardList() {
      if (!this.showPopup) return;

      // 데이터를 읽기 전 페이지 이동시 반복적으로 api를 호출하는 것을 막기위해 추가
      if (this.search.loading) return;
      this.search.loading = true;

      const projectId = this.projectId;

      this.initSort();
      this.initSearchKeyValue();
      this.initSearchCompanies();
      this.initSearchConditions();
      const conditions = this.search && this.search.conditions ? this.search.conditions : [];
      const boardId = this.boardId;
      const page = this.page.current;
      const perPage = this.page.perPage;

      let params = {
        projectId,
        boardId,
        boardSlug: `board-${boardId}`,
        page,
        perPage,
        orderTarget: "created_at",
        orderDirection: "desc",
        conditions,
        statusIds: [4]
      };

      // 날짜 검색
      if (!!this.search && !!this.search.created_at) {
        // 검색하는 날짜의 타겟을 불러온다
        const _ = { value: { created_at: {} } };
        if (this.listFileData.getSearchKeyValue) this.listFileData.getSearchKeyValue(_);

        if (boardId === 161) {
          params = { ...params, dateTarget: _.dateTarget, dateBegin: this.search.inputB_4.sDate, dateEnd: this.search.inputB_4.eDate };
        } else {
          params = { ...params, dateTarget: _.dateTarget, dateBegin: this.search.created_at.sDate, dateEnd: this.search.created_at.eDate };
        }
      }

      // 검색 조건
      if (this.listFileData.getSearchKeyword && this.listFileData.getSearchKeyword({ value: this.search }) && this.listFileData.getSearchKeyword({ value: this.search }).length > 0) {
        const keyword = this.listFileData.getSearchKeyword({ value: this.search }).map((_keyword) => {
          return _keyword.replace("[:default_skw]", this.search.searchKeyword).replace("[:default_disaster]", this.search.disasterType);
        });
        params = { ...params, keyword };
      }

      const response = this.tab.isApproval
        ? await this.$store.dispatch("approval/LOAD_POST_ALL", params)
        : await this.$store.dispatch("board/LOAD_POST_LIST", params)
      const { current_page, last_page, data } = response;

      // 불러온 데이터가 1이상 5미만일때 fakeList 를 사용한다.
      if (0 < data.length && data.length < 5) {
        const _tempArr = [];
        for (let index = 0; index < 5 - data.length; index++) {
          _tempArr.push({})
        }

        this.boardList = data;
        this.fakeList = _tempArr;
      } else {
        this.boardList = data;
        this.fakeList = [];
      }

      this.page.current = current_page;
      this.page.lastPage = last_page;

      for (const data of this.boardList) {
        data.checked = false;
      }
      this.search.loading = false;
    },

    // dotted path를 통해서 json 데이터를 찾는다
    // ex> findJsonDataWithDottedPath({a: {b: {c: 1}}}, 'a.b.c') => 1
    findJsonDataWithDottedPath(json, path) {
      try {
        const _keys = Object.keys(json);
        if (_keys.length === 0) {
          return "";
        }
        const paths = path.split(".");
        let result = json;
        for (const p of paths) {
          result = result[p];
        }
        return result;
      } catch (err) {
        return "";
      }
    },
    stringToObj(path, value, obj) {
      const parts = path.split(".");
      const last = parts.pop();
      let part;
      while ((part = parts.shift())) {
        if (typeof obj[part] !== "object") obj[part] = {};
        obj = obj[part]; // update "pointer"
      }
      obj[last] = value;
    },
    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.search.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },

    getColData(index, value) {
      const func = {
        getContent: this.getContent,
        getCreatedDate: this.getCreatedDate,
        getCompanyName: this.getCompanyName,
        getContentTargetList: this.getContentTargetList,
        onNameBlur: this.onNameBlur,
        getContentRiskList: this.getContentRiskList,
        getContentStringList: this.getContentStringList,
        comma: this.comma,
      }
      const __getCol = (index, value, func) => {
        const head = this.listFileData.getHead()[index];
        const keys = head.key.split(".");

        const keysLength = keys.length;
        if (keysLength === 1) {
          if (keys[0] === 'created_at') {
            return func.getCreatedDate(value.created_at)
          }
        }

        if (keysLength > 1) {
          const content = JSON.parse(value.post_content);
          const getData = (keys) => {
            let data = content;
            for (let i = 0; i < keys.length; i++) {
              data = data[keys[i]];
            }
            return data;
          }
          return getData(keys);
        }
      }
      if (this.listFileData.getCol) {
        return this.listFileData.getCol(index, value, func);
      } else {
        const data = __getCol(index, value, func);
        if (Array.isArray(data)) {
          return data.join(", ");
        }
        return data
      }
    },

    selectRowData(data) {
      if (this.multiSelect) return;

      if (this.selectData && this.selectData.id === data.id) {
        this.onClickUse();
      } else this.selectData = data;
    },

    // ======================= DATA FORMAT =========================

    getContentStringList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data)) {
          result += `${data},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    getContentRiskList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data.input_3)) {
          result += `${data.input_3},`;
        }
      }
      const newData = result.substring(0, result.length - 1);
      return newData.length <= 19 ? newData : `${newData.substring(0, 19)}...`;
    },
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    onNameBlur(name) {
      const length = name.length;
      if (2 < length) {
        const first = name[0];
        const last = name[name.length - 1];
        let star = "";
        for (let index = 0; index < length - 2; index++) {
          star += "*";
        }
        name = first + star + last;
      } else if (length === 2) {
        const first = name[0];
        name = `${first}*`;
      }
      return name;
    },
    getContentTargetList(list) {
      let result = "";
      for (const data of list) {
        if (!result.includes(data.target)) {
          result += `${data.target},`;
        }
      }
      return result.substring(0, result.length - 1);
    },
    getCompanyName(comId) {
      for (const com of this.companyList) {
        if (com.id === comId) {
          return com.com_name;
        }
      }
    },
    getCreatedDate(data) {
      if (data === "") return "";
      return moment(data).format("YYYY-MM-DD");
    },
    getContent(data) {
      if (data.post_content) {
        const content = JSON.parse(data.post_content);
        return content.body;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#popup::v-deep {
  .vs-popup {
    width: 90% !important;
    @media print, screen and (min-width: theme("screens.xl")) {
      width: 70% !important;
    }
  }
}
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 2px solid #f8f8f8;

  th,
  td {
    text-align: center;
    padding: 10px;
    transition: all 0.3s ease;
  }

  tr {
    cursor: pointer;

    &.fake {
      cursor: default;
    }

    &.select-row td {
      background-color: #6670cb !important;
      color: white;
    }

    &:nth-child(2n-1) {
      background-color: #f9f9f9;
    }
    &:hover {
      z-index: 200;

      td {
        -webkit-transform: translateY(-4px);
        transform: translateY(-4px);
      }
    }
  }
}
</style>
